import { Component } from '@angular/core';
import { envConfig } from 'src/env-config';

/** Build version shown on screen, same source as the RUM `version` (rum-init.util.ts). */
export function appVersion(): string {
  return envConfig.BUILD_VERSION || 'dev';
}

@Component({
  selector: 'app-version',
  standalone: true,
  // data-dd-action-name keeps a click (e.g. selecting the text to copy) from generating noisy actions.
  template: `<span class="app-version" data-dd-action-name="app_version">v{{ version }}</span>`,
  styleUrls: ['./app-version.component.scss'],
})
export class AppVersionComponent {
  readonly version = appVersion();
}
